module.exports = __webpack_public_path__ + "img/04_zhTc.c1d4d2cd.png";